import React from 'react';
import './GameHUD.css';

function GameHUD({
    score = 0,
    lives = 3,
    maxLives = 3,
    timeLeft = null,
    level = 1,
    combo = 0,
    xp = 0,
    coins = 0,
    onPause,
    gameName = 'Game',
    showCombo = true,
    showLives = true,
    showTimer = true
}) {
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    const getTimerClass = () => {
        if (timeLeft === null) return '';
        if (timeLeft <= 10) return 'timer-critical';
        if (timeLeft <= 30) return 'timer-warning';
        return '';
    };

    return (
        <div className="game-hud">
            <div className="hud-left">
                <div className="hud-game-name">
                    <span className="game-icon">🎮</span>
                    <span className="game-title">{gameName}</span>
                </div>
                {showLives && (
                    <div className="hud-lives">
                        {[...Array(maxLives)].map((_, i) => (
                            <span
                                key={i}
                                className={`life-heart ${i < lives ? 'active' : 'lost'}`}
                            >
                                {i < lives ? '❤️' : '🖤'}
                            </span>
                        ))}
                    </div>
                )}
            </div>

            <div className="hud-center">
                {showTimer && timeLeft !== null && (
                    <div className={`hud-timer ${getTimerClass()}`}>
                        <span className="timer-icon">⏱️</span>
                        <span className="timer-value">{formatTime(timeLeft)}</span>
                    </div>
                )}
                {showCombo && combo > 1 && (
                    <div className="hud-combo">
                        <span className="combo-value">{combo}x</span>
                        <span className="combo-label">COMBO!</span>
                    </div>
                )}
            </div>

            <div className="hud-right">
                <div className="hud-score">
                    <span className="score-label">Score</span>
                    <span className="score-value">{score.toLocaleString()}</span>
                </div>
                <div className="hud-rewards">
                    <span className="reward-xp">⭐ {xp}</span>
                    <span className="reward-coins">🪙 {coins}</span>
                </div>
                <button className="hud-pause-btn" onClick={onPause}>
                    ⏸️
                </button>
            </div>
        </div>
    );
}

export default GameHUD;
